exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".actions-tray-drawer__card[data-v-e2af705e]{height:auto!important}.actions-tray-drawer__card-media[data-v-e2af705e]{padding:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-e2af705e","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/actions-tray/ActionsTrayDrawer.vue
// module id = 1056
// module chunks = 22